<script setup lang="ts">
// utils
import dayjs from '@/utils/day';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiReviewHeaderProps {
  review: any;
  avatarSize?: 'sm' | 'md' | 'lg' | 'xl';
  isMobile?: boolean;
}
const props = withDefaults(defineProps<CiReviewHeaderProps>(), {
  avatarSize: 'lg',
  isMobile: false,
});

/********************
 * COMPOSITIONS      *
 ********************/
const backendStore = useBackendStore();

/********************
 * REFS & VARS       *
 ********************/
const getDateOfStay = computed(() => {
  if (props.review?.date_of_stay) {
    return dayjs(props.review.date_of_stay).format('MMMM YYYY');
  }

  return false;
});
</script>

<template>
  <div
    class="w-full items-center"
    :class="{ 'flex lg:hidden': isMobile, 'lg:block': !isMobile }"
  >
    <div class="flex lg:justify-center">
      <div class="z-10 w-[3.75rem] lg:w-[4.75rem]">
        <CiRatingRadial
          :rating="review.rating_overall"
          class="chart-wrapper chart-wrapper--border-md mx-auto block w-full"
          font-class="h6"
        />
      </div>
      <CiUserAvatar
        :size="avatarSize"
        :user-image="fixImageUrl(backendStore.url, review.user_profile_picture)"
        class="-ml-3 w-[3.75rem] lg:w-[4.75rem]"
        bg-class="bg-white p-2"
      />
    </div>
    <div class="ml-4 flex flex-col truncate lg:ml-0 lg:mt-6 lg:text-center">
      <span class="review__user font-medium">
        {{ review.user_display_name }}
      </span>
      <span
        v-if="getDateOfStay"
        class="text-small-book review__date-of-stay"
      >
        {{ getDateOfStay }}
      </span>
    </div>
  </div>
</template>

<style></style>
